export default [
  {
    position: "absolute",
    top: 1,
    left: 86,
    class: "dialog",
    animation: "pulsing",
    modalClass: "modal-top-right",
    isDialog: true,
    modal: false,
    mTitle: "absenceP2.mTitleOne",
    mBody: "absenceP2.mBodyOne",
    id: "SP_Absence_Info_LeaveRequest",
    infoIcon: true,
    isAction: false,
    index: 0
  },
  {
    position: "absolute",
    top: 1.1,
    left: 0.4,
    class: "tooltips",
    animation: "pulsing",
    isTooltip: true,
    navPos: 9,
    tooltipText: "absenceP2.ttTextOne",
    hover: false,
    tooltipClass: "right",
    id: "SP_Absence_Navigation_Menu",
    index: 1
  },
  {
    position: "absolute",
    top: 7.2,
    left: 13,
    class: "tooltips",
    animation: "pulsing",
    isTooltip: true,
    navPos: 0,
    tooltipText: "absenceP2.ttTextTwo",
    hover: false,
    id: "SP_Absence_Navigation_Communications",
    index: 2
  },
  {
    position: "absolute",
    top: 7.2,
    left: 35.3,
    class: "tooltips",
    animation: "pulsing",
    isTooltip: true,
    navPos: 3,
    tooltipText: "absenceP2.ttTextThree",
    hover: false,
    id: "SP_Absence_Navigation_PayBenefits",
    index: 3
  },
  {
    position: "absolute",
    top: 7.2,
    left: 50.1,
    class: "tooltips",
    animation: "pulsing",
    isTooltip: true,
    navPos: 7,
    tooltipText: "absenceP2.ttTextFour",
    hover: false,
    id: "SP_Absence_Navigation_Performance",
    index: 4
  },
  {
    position: "absolute",
    top: 7.2,
    left: 68.8,
    class: "tooltips",
    animation: "pulsing",
    isTooltip: true,
    navPos: 11,
    tooltipText: "absenceP2.ttTextFive",
    hover: false,
    id: "SP_Absence_Navigation_Hiring",
    index: 5
  },
  {
    position: "absolute",
    top: 5.3,
    left: 98.2,
    class: "tooltips",
    animation: "pulsing",
    isTooltip: true,
    navPos: 1,
    tooltipText: "absenceP2.ttTextSix",
    hover: false,
    tooltipClass: "left",
    id: "SP_Absence_Navigation_TeamMember",
    index: 6
  },
  {
    position: "absolute",
    top: 50.5,
    left: 16.5,
    class: "tooltips",
    animation: "pulsing",
    isTooltip: true,
    navPos: 6,
    tooltipText: "absenceP2.ttTextSeven",
    hover: false,
    tooltipClass: "left",
    id: "SP_Absence_Navigation_AbsenceRequest",
    index: 7
  },
];
